import React from 'react';
import PropTypes from 'prop-types';
import ProjectDeleteConfirmationDialogLayout from './ProjectDeleteConfirmationDialogLayout';

function ProjectDeleteConfirmationDialog(props) {
  return (
    <ProjectDeleteConfirmationDialogLayout
      onClose={props.onClose}
      open={props.open}
      project={props.project}
      handleDelete={props.handleDelete}
    />
  );
}

ProjectDeleteConfirmationDialog.defaultProps = {};

ProjectDeleteConfirmationDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  project: PropTypes.object,
  handleDelete: PropTypes.func,
};

export default ProjectDeleteConfirmationDialog;
